import { PlusIcon } from "@heroicons/react/24/outline";
import { ClipLoader } from "react-spinners";

const iconComponents = {
  PlusIcon: PlusIcon,
};

interface FullWidthButtonProps {
  className?: string;
  icon?: keyof typeof iconComponents;
  text: string;
  onClick: () => void;
  isInitialLoading?: boolean;
  disabled?: boolean;
}

const FullWidthButton: React.FC<FullWidthButtonProps> = ({
  className,
  icon,
  text,
  onClick,
  disabled,
  isInitialLoading,
}) => {
  const Icon = icon ? iconComponents[icon] : null;

  return (
    <button
      type="button"
      className={`${className} group relative flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-25`}
      onClick={onClick}
      disabled={disabled || isInitialLoading}
    >
      {isInitialLoading ? (
        <span className="flex items-center pl-2">
          <ClipLoader color="white" speedMultiplier={0.6} size={"1.25rem"} />
        </span>
      ) : (
        <>
          {text}
          {Icon && (
            <span className="flex items-center pl-2">
              <Icon className="h-5 w-5 text-white" aria-hidden="true" />
            </span>
          )}
        </>
      )}
    </button>
  );
};

export default FullWidthButton;
